export enum OverviewTab {
	POSITIONS = 'positions',
	ORDERS = 'orders',
	BALANCES = 'balances',
}

export enum MarketTab {
	WATCHLIST = 'Watchlist',
	TOP_MOVERS = 'Top Movers',
	TOP_LOSERS = 'Top Losers',
}

export enum PositionsTab {
	SMART_MARGIN = 'smart margin',
	CROSS_MARGIN = 'cross margin',
	SPOT = 'spot',
}
